// Store de notificações in-app (sino)
import { apiGet, apiPost } from '@/api/conserv';

// Lista as notificações mais recentes do usuário
export async function listaNotificacoes(limite = 50) {
    return apiGet(`api/Notificacoes/Lista?limite=${limite}`);
}

// Quantidade de não lidas (badge)
export async function contarNaoLidas() {
    return apiGet('api/Notificacoes/NaoLidas');
}

// Marca uma notificação como lida
export async function marcarLida(id) {
    return apiPost(`api/Notificacoes/MarcarLida?id=${encodeURIComponent(id)}`, '');
}

// Marca todas como lidas
export async function marcarTodasLidas() {
    return apiPost('api/Notificacoes/MarcarTodasLidas', '');
}
